import React, { useState } from "react";
import { Nav } from "shards-react";

import Notifications from "./Notifications";
import UserActions from "./UserActions";

const NavbarNav =  () => {
  const [noti, setNoti] = useState();
  const [useraction, setUseraction] = useState();
  const clickNoti = () => {
    !noti && useraction&& setUseraction(prev => !prev)
    setNoti(prev => !prev);
  }
  const clickUseraction = () => {
    !useraction && noti&& setNoti(prev => !prev)
    setUseraction(prev => !prev);
  }

  return(
  <Nav navbar className="border-left flex-row">
    <Notifications clickNoti={clickNoti} noti={noti}/>
    <UserActions clickUseraction={clickUseraction} useraction={useraction}/>
  </Nav>
  )
};

export default NavbarNav;